module.exports = __webpack_public_path__ + "static/media/Aau aba feri ranga bharau hai ta.b06a8127.wav";